import React from 'react'
import {
  Semantic,
  PageLayout,
  Text,
  CardContainer,
  Button,
} from '@adc/ui-morpheus'
import classnames from 'classnames/bind'
// @ts-ignore no types
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { ROOT_CRUMB } from '../../constants/routing'
import ChatNotebookIcon from '../chatNotebookPage/chatNotebookIcon'
import MyWorkSection from './myWorkSection'
// @ts-ignore next
import logo from '../../images/morpheus_logo.svg'
import styles from './styles.scss'

const cx = classnames.bind(styles)
const { Image } = Semantic // eslint-disable-line

interface HomePageProps {
  user: { party_id?: string }
  featureFlags: Record<string, boolean>
}

const HomePage: React.FC<HomePageProps> = ({ user, featureFlags }) => {
  return (
    <PageLayout
      title='Welcome to Morpheus'
      crumbs={[ROOT_CRUMB, 'Home']}
      cls={{ content: cx('content') }}
    >
      <div className={cx('pane')}>
        <CardContainer
          // @ts-ignore next
          backgroundColor='unset'
          className={cx('centered-content', 'card', 'logo-wrapper')}
          elmId='welcome_card'
        >
          {/* eslint-disable-next-line */}
          <Image src={logo} className={cx('logo')} />
          <Text
            color='gray'
            size='large'
            style={{
              textAlign: 'center',
            }}
          >
            Welcome to Morpheus, your access into the internal workings of
            Auction.com.
          </Text>
        </CardContainer>
      </div>

      <div className={cx('pane')}>
        <CardContainer
          dropShadow='small'
          className={cx('card')}
          elmId='recently_viewed_card'
        >
          <Text.Header level={3} elmId='recently_viewed_header'>
            Recently Viewed
          </Text.Header>
          <div
            className={cx('centered-content')}
            data-elm-id='recently_viewed_content'
          >
            <Text color='gray' size='large'>
              Coming Soon...
            </Text>
          </div>
        </CardContainer>
      </div>

      <div className={cx('pane')}>
        <CardContainer
          dropShadow='small'
          className={cx('card')}
          elmId='my_work_card'
        >
          {featureFlags['fe.resi.btbhome.enable-my-work-queue'] ? (
            <MyWorkSection partyId={user?.party_id || null} />
          ) : (
            <>
              <Text.Header level={3} elmId='my_work_header'>
                My Work
              </Text.Header>
              <div
                className={cx('centered-content')}
                data-elm-id='my_work_content'
              >
                <Text color='gray' size='large'>
                  Coming Soon...
                </Text>
              </div>
            </>
          )}
        </CardContainer>
      </div>

      <div className={cx('pane')}>
        <CardContainer
          dropShadow='small'
          className={cx('card')}
          elmId='chat_notebook_card'
        >
          <Text.Header level={3} elmId='chat_notebook_header'>
            Chat Notebook
          </Text.Header>
          <div
            className={cx('centered-content')}
            data-elm-id='chat_notebook_content'
          >
            <Text color='gray' size='large' style={{ textAlign: 'center' }}>
              Have a chat with one of our friendly AI Assistants!
            </Text>
            <ChatNotebookIcon />
          </div>
          <div className={cx('card-footer')}>
            <div className={cx('cognition-line')}>
              <Text color='gray' size='tiny' style={{ fontStyle: 'italic' }}>
                Brought to you by
              </Text>
              <img
                className={cx('cognition-logo')}
                src='https://adc-tenbox-prod.imgix.net/static/cognition-logo.v1.svg'
                alt='Cognition Logo'
              />
            </div>
            <Button
              role='primary'
              size='small'
              link='/chat-notebook'
              elmId='open_chat_notebook_button'
            >
              Open Chat Notebook
            </Button>
          </div>
        </CardContainer>
      </div>
    </PageLayout>
  )
}

export default connect(
  (store: {
    user: { party_id?: string }
    featureFlags: Record<string, boolean>
  }) => ({
    user: store.user,
    featureFlags: store.featureFlags,
  })
)(HomePage)
